
import {
    addExpenseApi,
    getCommonExpenseApi,
    getUserAccountList,
    handleKeyDown,
    uploadFiles,
} from "_services";
import {
    CommonDatePicker,
    CommonInput,
    CrossButton,
    CustomSelect,
    LoaderButton,
    SkeletonInput,
} from "components";
import { Images } from "constants";
import { UserContext } from "context";
import { addMultiExpeDriverTransaction } from "features";
import { errorSchema, utils } from "helper";
import AddEditModal from "modals/AddEditModal";
import { TripDetail } from "pages";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { getAllPermissions } from "utils/permissionHelper";
import StorageService from "utils/StorageServices/StorageServices";

const AddMultiExpenseModal = (props) => {
    const {
        isOpen,
        closeModal,
        callBackFreight,
        transactionList,
        tripDetais,
        venderDetailsFun
    } = props;
    const {
        masterData,
        globTripDetails,
        bankDetails,
        modalZIndex,
        setBankDetails,
        userSettingPermission,
        setModalZIndex,
        allMenu
    } = useContext(UserContext);

    const initiFrom = {
        category: "",
        sub_category: "",
        expense_category: "",
        amount: "",
        txn_date: new Date(),
        account_category: "",
        account_sub_category: "",
        account_id: "",
        description: "",
        vendor_type: "",
        vendor_account: "",
        lr_id: "",
        trip_id: props?.tripId,
        branch_id: "",
        company_id: StorageService.getCompanyId(),
        vehicle_id: "",
        file: [],
    };

    const expenseInit = {
        category: '',
        description: "",
        amount: "",
        no_of_days: 0,
        days_rate: 0,
        perc_of_revenue: 0,
        categoryDetails: {}
    };

    const dispatch = useDispatch();

    const [form, setForm] = useState(initiFrom);
    const [formError, setFormError] = useState("");
    const [freightTypeList, setFreightTypeList] = useState([]);
    const [freigtAccount, setFreigtAccount] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
    const [bankAccountList, setBankAccountList] = useState([]);
    const [isLoadding, setIsLoadding] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [accountType, setAccountType] = useState();
    const [accountLoading, setAccountLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [expenseDetails, setExpenseDetails] = useState("");
    const [commExpenseList, setCommExpenseList] = useState([]);
    const [isloadingSend, setIsloadingSend] = useState(false);
    const styleZindex = {
        zIndex: -1,
    };
    const [expenseArray, setExpenseArray] = useState([expenseInit]);
    const [isOpenFuelModal, setIsOpenFuelModal] = useState(false);
    const [expenseIndex, setExpenseIndex] = useState('')
    const [bankRequiredDetails, setBankRequiredDetails] = useState({})
    const balance = transactionList?.freight_summary?.total_freight
    const hasLinkPermission = getAllPermissions("Accounts", allMenu, 'label');
    const hasLinkCharofAccountPermission = getAllPermissions("/accounting/chartofaccounts", allMenu, 'link');



    useEffect(() => {
        if (masterData) {
            getMasterFreight();
        }
    }, [masterData]);

    useEffect(() => {
        if (!isCheck) {
            setBankDetails("");
        }
    }, [isCheck]);

    useEffect(() => {
        if (bankDetails && form?.category) {
            setForm({ ...form, vendor_account: bankDetails?._id });
        }
    }, [bankDetails, form?.category]);

    useEffect(() => {
        if (
            (form?.account_sub_category && form?.account_category,
                freigtAccount.length)
        ) {
            if (form?.account_id == "" && form?.account_sub_category != 11) {
                getAccountListHandler();
            }
        }
    }, [
        form?.account_sub_category,
        form?.account_category,
        freigtAccount,
        form?.account_id,
    ]);

    useEffect(() => {
        if (accountType) {
            setForm({ ...form, account_id: "", vendor_account: "" });
            setBankDetails("");
        }
    }, [accountType]);

    useEffect(() => {
        if (props?.accountList?.length > 0) {
            let list = props?.accountList?.map((i) => {
                return {
                    ...i,
                    label: i?.bank_name || i?.account_name || i?.upi_id,
                    value: i?._id,
                };
            });
            setBankAccountList(list);
        }
    }, [props?.accountList]);

    const getMasterFreight = async () => {
        const payload = {
            type: "add_freight",
        };

        try {
            const details = masterData?.driver_trip_charges?.sub_type?.map((item) => {
                return {
                    label: item?.name,
                    value: item?.id,
                    id: item?._id,
                    status: item?.status,
                    category_id: masterData?.driver_trip_charges?.id,
                    type: masterData?.driver_trip_charges?.type,
                };
            });

            const detailsAccount =
                masterData?.own_account_category?.sub_category?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?.id,
                        category_id: masterData?.own_account_category?.id,
                    };
                })
                    .filter((item) => item.value !== 28);

            // const desiredOrder = ["Driver Khata", "Cash", "Bank", "Other", "Balance"];
            const desiredOrder = [11, 3, 2, 27, 14, 10, 28];

            const sortedData = detailsAccount.sort(
                (a, b) => desiredOrder.indexOf(a.value) - desiredOrder.indexOf(b.value)
            );

            if (sortedData && details) {
                setForm({
                    ...form,
                    trip_id: props?.tripId,
                    category: details[0]?.category_id,
                    sub_category: details[0]?.value,
                    account_category: sortedData[0]?.category_id,
                    account_sub_category: sortedData[0]?.value,
                });

                setFreigtAccount(sortedData);
                setFreightTypeList(details);
            }
        } catch { }
    };

    useEffect(() => {
        if (form?.sub_category) {
            getCommonExpense(form?.sub_category);
            handleOnChange("expense_category", "");
        }
    }, [form?.sub_category]);

    useEffect(() => {
        let value = false;

        // 1️⃣ bankRequiredDetails rule
        if (bankRequiredDetails?.vendor_account === true && form?.account_sub_category == 2) {

            value = true;
        }

        // 2️⃣ form/account rules
        if (form?.account_id === "") {
            value = false;
        }

        if (form?.account_sub_category == 27 || form?.account_sub_category == 28) {
            value = true;
        }

        // Final update in one place:
        setIsCheck(value);

    }, [
        bankRequiredDetails,
        form?.account_sub_category,
        form?.account_id,
    ]);

    const getCommonExpense = async (expense) => {
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                category_id: expense == 1 ? 5 : 4,
                sub_category_id: expense == 1 ? 7 : 6,
            };
            const res = await getCommonExpenseApi(payload);

            if (res?.responseCode === 200) {
                const details = res?.data?.categories?.map((item) => {
                    return {
                        ...item,
                        label: item?.name,
                        value: item?._id,
                    };
                });
                setCommExpenseList(details);
                setExpenseDetails(res?.data);
            } else {
            }
        } catch (error) { }
    };

    const getAccountListHandler = async () => {
        setAccountLoading(true);
        try {
            const res = await getUserAccountList({
                company_id: StorageService?.getCompanyId(),
                category_id: parseInt(form?.account_category),
                sub_category_id: parseInt(form?.account_sub_category),
                firm_id: tripDetais?.interfirm == 1 ? tripDetais?.vehicle_firm?._id : tripDetais?.firm_id?._id
            });

            if (res?.responseCode === 200) {
                setAccountLoading(false);
                const details = res?.data?.account_list?.map((item) => {
                    return {
                        ...item,
                        label: item?.name,
                        value: item?._id,
                    };
                });
                setAccountList(details);
                handleOnChange("account_id", details[0].value);
                setAccountLoading(false);
                setBankRequiredDetails(details[0])
            } else {
                setAccountLoading(false);
                setAccountList([]);
            }
        } catch (error) {
            setAccountLoading(false);
            setAccountList([]);
        }
    };

    const handleOnChange = async (name, value) => {
        const stateObj = {
            ...form,
            [name]: value,
        };
        setForm(stateObj);

        if (!!formError) {
            const validationResult = await utils.checkFormError(
                { ...stateObj },
                errorSchema.addOwnChargeSchema
            );
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const validateInput = (value) => {
        const number = parseFloat(value);
        return (
            number <=
            props?.transactionList?.freight_summary?.freight_summary?.balance
        );
    };

    const onSubmitFreight = async (approve) => {

        let arrayData = expenseArray?.map((el) => ({
            ...el,
            category: el?.category?.value ? el?.category?.value : '',
            categoryDetails: el?.categoryDetails || {}
        }))

        const validationResult = await utils.checkFormError(
            { ...form, balance: globTripDetails?.driver_id?.balance, expenseArray: arrayData },
            errorSchema.multiExpenseTripSchema
        );
        console.log("validationResult", validationResult)

        const formattedExpenseArray = expenseArray.map((expense) => ({
            ...expense,
            amount: parseFloat(parseFloat(expense.amount || 0).toFixed(2)),
            category: {
                _id: expense?.category?.value ? expense?.category?.value : '',
                name: expense?.category?.label ? expense?.category?.label : ''
            },
            no_of_days: expense.no_of_days?.toString() || "0",
            days_rate: expense.days_rate?.toString() || "0",
            perc_of_revenue: expense.perc_of_revenue?.toString() || "0"
        }));

        const payload = {
            type: form?.category ? parseInt(form?.category) : "",
            sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
            expenses: formattedExpenseArray,
            date: utils.convertToISO(form?.txn_date, true),
            account_category: form?.account_category
                ? parseInt(form?.account_category)
                : "",
            account_sub_category: form?.account_sub_category
                ? parseInt(form?.account_sub_category)
                : "",
            account_id: form?.account_id ? form?.account_id : "",
            lr_id: "",
            trip_id: props.tripId,
            branch_id: globTripDetails?.branch_id?._id,
            company_id: form?.company_id,
            is_approval: approve,
            file: form?.file,
            total_amount: calculateTotalAmount(),
            vender_type: 4,
            vendor_bank_account: bankDetails ? bankDetails?._id : "",

        };

        if (validationResult === true) {
            approve == 0 ? setIsLoadding(true) : setIsloadingSend(true);
            try {
                const res = await dispatch(addMultiExpeDriverTransaction(payload));

                if (res?.payload?.responseCode === 200) {
                    setIsLoadding(false);
                    setIsloadingSend(false);
                    callBackFreight();
                    closeModal();
                    toast.success("Created");
                } else {
                    setIsLoadding(false);
                    setIsloadingSend(false);
                }
            } catch {
                setIsLoadding(false);
                setIsloadingSend(false);
            }
        } else {
            setFormError(validationResult);
            setIsLoadding(false);
            setIsloadingSend(false)
        }
    };

    const modifyProps = {
        ...props,
        onSubmit: onSubmitFreight,
        isLoadding: isLoadding,
        disabled: isLoadding,
        isLoadingSave: isLoadingSave,
    };

    const handleFileChange = async (e) => {
        const file = e?.target?.files[0];
        const allowedImageTypes = ["image/gif", "image/jpeg", "image/png"];
        const allowedPdfType = "application/pdf";

        if (file) {
            if (allowedImageTypes.includes(file.type)) {
                setLoading(true);
                try {
                    const formData = new FormData();
                    formData.append("file", file);
                    const res = await uploadFiles(formData);
                    if (res?.responseCode === 200) {
                        const fileArray = [
                            ...(form?.file || []),
                            {
                                filename: res?.data?.filename,
                                path: res?.data?.path,
                            },
                        ];
                        handleOnChange("file", fileArray);
                        setLoading(false);
                        toast.success("Image added successfully.");
                    }
                } catch (error) {
                    setLoading(false);
                    toast.error("Failed to upload image. Please try again.");
                }
            } else if (file.type === allowedPdfType) {
                setLoading(true);
                try {
                    const formData = new FormData();
                    formData.append("file", file);
                    const res = await uploadFiles(formData);
                    if (res?.responseCode === 200) {
                        const fileArray = [
                            ...(form?.file || []),
                            {
                                filename: res?.data?.filename,
                                path: res?.data?.path,
                            },
                        ];
                        handleOnChange("file", fileArray);
                        setLoading(false);
                        toast.success("PDF added successfully.");
                    }
                } catch (error) {
                    setLoading(false);
                    toast.error("Failed to upload PDF. Please try again.");
                }
            } else {
                toast.error("Invalid file type. Please choose a JPEG, PNG, or PDF file.");
            }
        } else {
            toast.error("No file selected.");
        }
    };

    const documentRemove = (index) => {
        const newFromIput = [...form?.file];
        newFromIput.splice(index, 1);
        setForm({ ...form, file: newFromIput });
    };

    const filterList = (claimAccount) => {
        return claimAccount?.filter((i) => i.value != 10);
    };

    const isExpense = form?.sub_category == 1;
    const categoryLabel = isExpense ? "Expense Category" : "Receipt Category";
    const categoryPlace = isExpense ? "Select Expense Category" : " Select Receipt Category";
    const categoryOptions = commExpenseList || [{ label: "", value: "" }];
    const selectedCategory = commExpenseList?.find(
        (i) => i.value === form?.expense_category
    );
    const selectedPartyCategory = commExpenseList?.find(
        (i) => i.value === form?.party_expense_category
    );

    const totalbalance = props?.transactionList?.freight_summary?.balance || 0;
    const amount = form?.amount || 0;

    const callBackApi = (data) => {
        const formate = { ...data?.category, label: data?.category?.name, value: data?.category?._id }
        getCommonExpense(form?.sub_category);
        const list = [...expenseArray];
        list[expenseIndex]["category"] = formate;
        list[expenseIndex]["categoryDetails"] = formate;
        list[expenseIndex]["no_of_days"] = 0;
        list[expenseIndex]["days_rate"] = 0;
        list[expenseIndex]["perc_of_revenue"] = 0;
        list[expenseIndex]["amount"] = "";
        setExpenseArray(list);
        callBackFreight();
    };

    const addExpenseHandle = (index) => {
        setExpenseIndex(index)
        setIsOpenFuelModal(true);
    };

    let openZoneModal = {
        isOpen: isOpenFuelModal,
        closeModal: (e) => setIsOpenFuelModal(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle:
            form?.sub_category == 1 ? "Add Trip Expenses" : "Add Trip Receipt",
        submitTitle:
            form?.sub_category == 1 ? "Add Trip Expenses" : "Add Trip Receipt",
        footerPart: true,
        label: form?.sub_category == 1 ? "Expenses Name" : " Receipt Name",
        placeholder:
            form?.sub_category == 1 ? "Enter Expenses Name" : "Enter Receipt Name",
        ApiPoint: addExpenseApi,
        callBackApi: callBackApi,
        payloadData: {
            category_id: (form?.sub_category == 1) == 1 ? 5 : 4,
            sub_category_id: (form?.sub_category == 1) == 1 ? 7 : 6,
        },
        titleName: "Trip",
    };

    const handleExpenseChange = async (value, index, name) => {
        const list = [...expenseArray];
        list[index][name] = value;

        // Auto-calculate amount based on calculation_type
        const categoryDetails = list[index]?.categoryDetails;

        if (categoryDetails?.calculation_type === 2) {
            // Calculate: no_of_days * days_rate
            const days = parseFloat(list[index].no_of_days) || 0;
            const rate = parseFloat(list[index].days_rate) || 0;
            list[index].amount = (days * rate).toString();
        } else if (categoryDetails?.calculation_type === 3) {
            // Calculate: (total_freight * perc_of_revenue) / 100
            const percentage = parseFloat(list[index].perc_of_revenue) || 0;
            const totalFreight = balance || 0;
            list[index].amount = ((totalFreight * percentage) / 100).toString();
        }

        setExpenseArray(list);

        let arrayData = list?.map((el) => ({
            ...el,
            category: el?.category?.value ? el?.category?.value : '',
            categoryDetails: el?.categoryDetails || {}
        }))

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.dynamicCheckFormError(
                { ...form, expenseArray: arrayData },
                errorSchema.multiExpenseTripSchema
            );
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    const removeExpenseInput = (index) => {
        const newExpense = [...expenseArray];
        newExpense.splice(index, 1);
        setExpenseArray(newExpense);
    };

    const addExpenseInput = (e) => {
        setExpenseArray((preState) => {
            return [...preState, expenseInit];
        });
    };

    const calculateTotalAmount = () => {
        const exTotal = expenseArray?.reduce((total, item) => {
            const amount = parseFloat(item?.amount) || 0;
            return total + amount;
        }, 0);

        return exTotal.toFixed(2);
    };

    return (
        <div>
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{
                    visibility: isOpen ? "visible" : "hidden",
                    display: modalZIndex ? "none" : "",
                    width: "595px",
                    backgroundColor: "#ffff",
                }}
            >
                {isOpen && (
                    <>
                        <div className="offcanvas-header headWith_back">
                            <h5 className="offcanvas-title">
                                Trip Charges
                            </h5>
                            <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={closeModal}>
                                <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                                    <path
                                        d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                        fill="black"
                                    />
                                </svg>
                            </CrossButton>
                        </div>

                        <>
                            <div className="offcanvas-body">
                                <div className="__addExp_body">
                                    <div className="flxInr">
                                        <div className="halfDiv ps-3">
                                            <CommonDatePicker
                                                name="date"
                                                label="Expense Date"
                                                startDate={form?.txn_date}
                                                setStartDate={(data) => {
                                                    handleOnChange("txn_date", data);
                                                }}
                                                error={formError?.txn_date}
                                                focus={!!formError?.txn_date}
                                                maxDate={new Date()}
                                            />
                                        </div>

                                        <div className="singleDiv ">
                                            <div className="_catGry_tableBx _withGst_catGry">
                                                <div className="__catrTb_row __catrTb_head">
                                                    <div className="__cat_childs">
                                                        <h5>Expense Category</h5>
                                                    </div>
                                                    <div className="__cat_childs">
                                                        <h5>Item Description</h5>
                                                    </div>
                                                    <div className="__cat_childs">
                                                        <h5>Amount (₹)</h5>
                                                    </div>
                                                </div>

                                                {expenseArray?.map((exp, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div className="__catrTb_row __catrTb_body">
                                                                <div className="__cat_childs">
                                                                    <div className="mt-1">
                                                                        <CustomSelect
                                                                            label={categoryLabel}
                                                                            options={categoryOptions}
                                                                            placeholder={categoryPlace}
                                                                            onSelect={(data) => {
                                                                                const list = [...expenseArray];
                                                                                list[index].category = data;
                                                                                list[index].categoryDetails = data;
                                                                                list[index].no_of_days = 0;
                                                                                list[index].days_rate = 0;
                                                                                list[index].perc_of_revenue = 0;
                                                                                list[index].amount = "";
                                                                                setExpenseArray(list);
                                                                                handleExpenseChange(data, index, "category");
                                                                            }}
                                                                            error={
                                                                                formError[
                                                                                `expenseArray[${index}].category`
                                                                                ]
                                                                            }
                                                                            focus={
                                                                                !!formError[
                                                                                `expenseArray[${index}].category`
                                                                                ]
                                                                            }
                                                                            value={expenseArray[index].category}
                                                                            isAddButton={hasLinkCharofAccountPermission?.canCreate ? true : false}
                                                                            addButtonAction={() => {
                                                                                addExpenseHandle(index)
                                                                            }}
                                                                            errorShow={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="__cat_childs">   <div className="mt-1">
                                                                    <CommonInput
                                                                        type="text"
                                                                        placeholder="Item Description"
                                                                        name="description"
                                                                        value={exp?.description}
                                                                        onChange={({ target: { name, value } }) => {
                                                                            handleExpenseChange(
                                                                                value,
                                                                                index,
                                                                                "description"
                                                                            );
                                                                        }}
                                                                        focus={
                                                                            !!formError[
                                                                            `expenseArray[${index}].description`
                                                                            ]
                                                                        }
                                                                        error={
                                                                            formError[
                                                                            `expenseArray[${index}].description`
                                                                            ]
                                                                        }
                                                                        errorShow={true}
                                                                    />
                                                                </div></div>


                                                                {expenseArray[index]?.categoryDetails?.calculation_type === 2 && (
                                                                    <><div className="__cat_childs">
                                                                        <div className="mt-1">
                                                                            <CommonInput
                                                                                type="text"
                                                                                label="No of Days"
                                                                                placeholder="No of Days"
                                                                                name="no_of_days"
                                                                                value={exp?.no_of_days ? exp?.no_of_days : ""}
                                                                                // onChange={({ target: { name, value } }) => {
                                                                                //     handleExpenseChange(value, index, "no_of_days");
                                                                                // }}

                                                                                onChange={({ target: { name, value } }) => {
                                                                                    if (/^0[0-9]/.test(value)) {
                                                                                        value = value.replace(/^0+/, ''); // "01" → "1"
                                                                                    }

                                                                                    // Allow "0." for decimals but not "0x" where x is digit
                                                                                    if (value === "0") {
                                                                                        handleExpenseChange(value, index, "no_of_days");
                                                                                        return;
                                                                                    }
                                                                                    handleExpenseChange(value, index, "no_of_days");
                                                                                }}
                                                                                onKeyDown={handleKeyDown}
                                                                                focus={!!formError[`expenseArray[${index}].no_of_days`]}
                                                                                error={formError[`expenseArray[${index}].no_of_days`]}
                                                                                errorShow={true}
                                                                                maxLength={3}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                        <div className="__cat_childs">
                                                                            <div className="mt-1">
                                                                                <CommonInput
                                                                                    type="text"
                                                                                    label="Rate"
                                                                                    placeholder="Rate"
                                                                                    name="days_rate"
                                                                                    value={exp?.days_rate ? exp?.days_rate : ""}
                                                                                    // onChange={({ target: { name, value } }) => {
                                                                                    //     handleExpenseChange(value, index, "days_rate");
                                                                                    // }}
                                                                                    onChange={({ target: { name, value } }) => {
                                                                                        if (/^0[0-9]/.test(value)) {
                                                                                            value = value.replace(/^0+/, ''); // "01" → "1"
                                                                                        }

                                                                                        // Allow "0." for decimals but not "0x" where x is digit
                                                                                        if (value === "0") {
                                                                                            handleExpenseChange(value, index, "days_rate");
                                                                                            return;
                                                                                        }
                                                                                        handleExpenseChange(value, index, "days_rate");
                                                                                    }}
                                                                                    onKeyDown={handleKeyDown}
                                                                                    focus={!!formError[`expenseArray[${index}].days_rate`]}
                                                                                    error={formError[`expenseArray[${index}].days_rate`]}
                                                                                    errorShow={true}
                                                                                    maxLength={6}
                                                                                />
                                                                            </div>
                                                                        </div></>


                                                                )}

                                                                {expenseArray[index]?.categoryDetails?.calculation_type === 3 && (
                                                                    <div className="__cat_childs">
                                                                        <div className="mt-1">
                                                                            <CommonInput
                                                                                type="text"
                                                                                label="% of Revenue"
                                                                                placeholder="% of Revenue"
                                                                                name="perc_of_revenue"
                                                                                value={exp?.perc_of_revenue ? exp?.perc_of_revenue : ""}
                                                                                // onChange={({ target: { name, value } }) => {
                                                                                //     handleExpenseChange(value, index, "perc_of_revenue");
                                                                                // }}
                                                                                onChange={({ target: { name, value } }) => {
                                                                                    if (/^0[0-9]/.test(value)) {
                                                                                        value = value.replace(/^0+/, ''); // "01" → "1"
                                                                                    }

                                                                                    // Allow "0." for decimals but not "0x" where x is digit
                                                                                    if (value === "0") {
                                                                                        handleExpenseChange(value, index, "perc_of_revenue");
                                                                                        return;
                                                                                    }
                                                                                    handleExpenseChange(value, index, "perc_of_revenue");
                                                                                }}
                                                                                onKeyDown={handleKeyDown}
                                                                                focus={!!formError[`expenseArray[${index}].perc_of_revenue`]}
                                                                                error={formError[`expenseArray[${index}].perc_of_revenue`]}
                                                                                postText="%"
                                                                                postAddon={true}
                                                                                errorShow={true}
                                                                                maxLength={3}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="__cat_childs">
                                                                    <div className="mt-1">
                                                                        <CommonInput
                                                                            type="text"
                                                                            placeholder="Amount (₹)"
                                                                            name="amount"
                                                                            maxLength="12"
                                                                            onInput={maxLengthCheck}
                                                                            value={exp?.amount ? exp?.amount : ""}
                                                                            onChange={({ target: { name, value } }) => {
                                                                                if (/^0[0-9]/.test(value)) {
                                                                                    value = value.replace(/^0+/, '');
                                                                                }
                                                                                if (value === "0") {
                                                                                    handleExpenseChange(value, index, "amount");
                                                                                    return;
                                                                                }
                                                                                handleExpenseChange(value, index, "amount")
                                                                            }}
                                                                            focus={
                                                                                !!formError[`expenseArray[${index}].amount`]
                                                                            }
                                                                            error={formError[`expenseArray[${index}].amount`]}
                                                                            errorShow={true}
                                                                            onKeyDown={handleKeyDown}
                                                                            disabled={
                                                                                expenseArray[index]?.categoryDetails?.calculation_type === 2 ||
                                                                                expenseArray[index]?.categoryDetails?.calculation_type === 3
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {expenseArray.length > 1 && (
                                                                    <div className="mt-2">
                                                                        <img
                                                                            className="_delExp"
                                                                            src={Images.DELETEICON.default}
                                                                            alt=""
                                                                            onClick={() => removeExpenseInput(index)}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        <div className="singleDiv ">
                                            <div className=" totalExp_bal pt-2">
                                                <button
                                                    className="__adx_more "
                                                    onClick={() => addExpenseInput()}
                                                >
                                                    + Add More
                                                </button>

                                                <div className="__sideTl_detail">
                                                    <div className="_alInvoiceSumry">
                                                        <div className="_invsSum_fx">
                                                            <p className="_blackText"> Total </p>
                                                            <p className="_blackText">{`₹ ${calculateTotalAmount()}`}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="singleDiv p-3">
                                            <div className="_payMode_hed">
                                                <h4>
                                                    {form?.sub_category == 1
                                                        ? "Paid By Driver (Credit)"
                                                        : "Received By Driver (Debit)"}
                                                </h4>
                                                {filterList(freigtAccount)?.map((i) => (
                                                    <button
                                                        className={`_baseSpan ${i?.value == form?.account_sub_category
                                                            ? ""
                                                            : "_bspDisable"
                                                            }`}
                                                        disabled={accountLoading}
                                                        name="account_sub_category"
                                                        value={i.value}
                                                        onClick={({ target: { name, value } }) => {
                                                            handleOnChange(name, value);
                                                            setAccountType(value);

                                                            if (value == 2 || value == 27 || value == 28) {
                                                                venderDetailsFun({ vender_type: 3, vender_id: globTripDetails?.driver_id?._id })
                                                            }
                                                        }}
                                                    >
                                                        {i.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {form?.account_sub_category != 11 && (
                                            <>
                                                {!accountLoading ? (
                                                    <div className="singleDiv " style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
                                                        <CustomSelect
                                                            label="Select Account"
                                                            name="account_id"
                                                            onSelect={(data) => {
                                                                handleOnChange("account_id", data.value);
                                                                setBankRequiredDetails(data)
                                                            }}
                                                            value={
                                                                form?.account_id
                                                                    ? accountList?.find(
                                                                        (i) => i.value == form?.account_id
                                                                    )
                                                                    : { label: "", value: "" }
                                                            }
                                                            options={accountList}
                                                            focus={!!formError?.account_id}
                                                            error={formError.account_id}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="singleDiv " style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
                                                        <SkeletonInput isLoading={accountLoading} />
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {form?.account_sub_category == 11 && (
                                            <div style={{ paddingLeft: "1rem" }}>Driver - {globTripDetails?.driver_id?.name}</div>
                                        )}
                                        {/* {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && (
                                            <div style={{ paddingLeft: "1rem" }}>
                                                <input
                                                    type="checkbox"
                                                    id="vehicle1"
                                                    name="vehicle1"
                                                    // value="Bike"
                                                    checked={isCheck}
                                                    disabled={form?.account_sub_category == 27 || form?.account_sub_category == 28 || bankRequiredDetails?.vendor_account === true}
                                                    onChange={({ target: { name, checked } }) => {
                                                        setIsCheck(checked);
                                                        handleOnChange("isCheck", checked);
                                                    }}

                                                />
                                                <label for="vehicle1"> Select Supplier Bank Account</label>
                                                <br />
                                            </div>
                                        )}
                                        {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && isCheck && (
                                            <div className="singleDiv"
                                                onClick={() => {
                                                    // props?.setIsOpenFreight(false);
                                                    setModalZIndex(-1);
                                                    props?.setCanvasOpen(true);
                                                }}
                                                style={{ paddingLeft: "1rem" }}
                                            >
                                                <CustomSelect
                                                    label="Select Supplier Account"
                                                    options={bankAccountList}
                                                    disabled={!isCheck}
                                                    openList={false}
                                                    value={
                                                        bankDetails
                                                            ? bankAccountList?.find(
                                                                (i) => i?.value === bankDetails?._id
                                                            )
                                                            : { label: "", value: "" }
                                                    }
                                                    focus={!!formError?.vendor_account}
                                                    error={formError.vendor_account}
                                                />
                                            </div>
                                        )} */}
                                        <div className="singleDiv p-3">
                                            <div className="_attatchmentBxs">
                                                <h4>Attachment</h4>
                                                <div className="_athBxs">
                                                    <input
                                                        type="file"
                                                        id="_fileUpload"
                                                        onClick={(e) => {
                                                            if (form?.file?.length >= 5) {
                                                                e.preventDefault();
                                                                toast.error("You can upload only 5 files");
                                                            }
                                                        }}
                                                        onChange={(e) => handleFileChange(e, "first")}
                                                    />
                                                    <label
                                                        htmlFor="_fileUpload"
                                                        className="_uploadBtn"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="19"
                                                            viewBox="0 0 20 19"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                                                                fill="#1956F6"
                                                            />
                                                        </svg>
                                                        <span>
                                                            {loading ? "Uploadding" : "Add File"}
                                                        </span>
                                                    </label>
                                                    {formError?.file && (
                                                        <span className="input_drop_error">
                                                            {formError?.file}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="img_fnex_src">
                                                    {form?.file?.length > 0 &&
                                                        form?.file?.map((el, index) => {
                                                            return (
                                                                <>
                                                                    <div className="pos-relative">
                                                                        <img
                                                                            className="_pdfIcon_sigxe"
                                                                            src={`${masterData?.s3_url}${el?.path}`}
                                                                            alt=""
                                                                        />
                                                                        <span className="_clDel_icon">
                                                                            <IoCloseCircle
                                                                                onClick={() =>
                                                                                    documentRemove(index)
                                                                                }
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                </>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {form?.account_sub_category == 11 && (
                                <div className="_balSuccess">
                                    <p>Driver Khata Balance:</p>
                                    <p>
                                        {form?.sub_category == 1
                                            ? ` ${globTripDetails?.driver_id?.balance} - ${calculateTotalAmount()} = ₹ ${Number(globTripDetails?.driver_id?.balance) - Number(calculateTotalAmount() || 0)} `
                                            : ` ${globTripDetails?.driver_id?.balance} + ${calculateTotalAmount()} = ₹ ${Number(globTripDetails?.driver_id?.balance || 0) + Number(calculateTotalAmount() || 0)} `}
                                    </p>
                                </div>
                            )}
                        </>

                        <div className="offcanvas-footer">
                            {form?.account_sub_category == 27 || bankRequiredDetails?.expenses_approval ? Number(bankRequiredDetails?.expenses_approval) !== 1 : userSettingPermission?.expenses_approval !== 1 && (
                                <LoaderButton
                                    onClick={() => onSubmitFreight(0)}
                                    isLoadingText="Processing..."
                                    className="multi_submitOn_modal"
                                    loaderClass="custom-spinner"
                                    disabled={isLoadding || isloadingSend}
                                    isLoading={isLoadding}
                                >
                                    Add Expense
                                </LoaderButton>
                            )}

                            <LoaderButton
                                onClick={() => onSubmitFreight(1)}
                                isLoading={isloadingSend}
                                isLoadingText="Processing..."
                                className="multi_cancel_btn"
                                disabled={isloadingSend || isLoadding}
                                loaderClass="custom-spinner"
                            >
                                Send For Approval
                            </LoaderButton>

                            <LoaderButton
                                onClick={() => closeModal()}
                                isLoadingText="Processing..."
                                className="multi_cancel_btn"
                                loaderClass="custom-spinner"
                            >
                                Cancel
                            </LoaderButton>
                        </div>
                    </>
                )}
            </div>
            <div className={isOpen ? "offBack_drop" : ""}></div>
            {isOpenFuelModal && <AddEditModal {...openZoneModal} />}
        </div>
    );
};

export default AddMultiExpenseModal;
